<template>
  <div class="centered-container">
    <md-content class="md-elevation-3">
        <div class="title" >
            <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
            <div class="md-body-1">Opening Application...</div>
        </div>
    </md-content>
    <div class="background"/>
  </div>
</template>

<script>
import * as types from '../store/event_types'

export default {
    name: "Mobile",
    data() {
        return {
        }
    },
    methods: {
        next(){
          if(this.$route.query.page && this.$route.query.page.startsWith("circle-welcome://")){
            this.$store.dispatch(types.START_MOBILE, this.$route.query.page)
          }
        }
    },
    mounted () {
        this.next()
    }
}
</script>
